<template>
    <div>
        <navigation-bar Back Bell/>
        <div class="main">
            <item-grid class="two-gird">
                <!--TODO:領取優惠券清單-->
                <ticket-item :list="couponList">
                    <img src="@/assets/images/tag3.svg" alt="">
                </ticket-item>
            </item-grid>
        </div>
    </div>

</template>

<script>
    import ItemGrid from '@/components/category/ItemGrid.vue'
    import TicketItem from '@/views/home/components/TicketItem.vue'
export default {
    name: 'CouponList',
    components: {
        ItemGrid,
        TicketItem,
    },
    data() {
        return {
            couponList: [],
        }
    },
    created() {
        this.setupData();
    },
    methods:{
        setupData: function () {
            //優惠卷清單
            this.$http.fetch`GetCouponList${{
                isShowHome: 1,
                showArea: 0,
            }} ${json => {
                this.couponList = json.data;
            }}`;
        }
    }
}
</script>
